const INFORMATION_IMPOSSIBILITY_ENTITY_NAME = 'get.information.on.impossibility';

/**
 * Возвращает URL API для модального окна формы по имени сущности.
 *
 * Функция проверяет имя сущности и возвращает соответствующий путь API,
 * если оно совпадает с поддерживаемым именем. В противном случае возвращает undefined.
 *
 * @param entityName - Имя сущности, для которой нужно получить URL API.
 * @returns Строка с URL API для модального окна формы или undefined,
 * если имя сущности не поддерживается.
 */
export const getApiUrlForFormModal = (entityName: string): string | undefined => {
    switch (entityName) {
    case INFORMATION_IMPOSSIBILITY_ENTITY_NAME:
        return `integration.module/document.inventory/${INFORMATION_IMPOSSIBILITY_ENTITY_NAME}`;
    default:
        return undefined;
    }
};
